import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
  clearEnrollAbandoned,
  clearEnrollExpired,
  useEnrollAbandoned,
  useEnrollExpired,
} from "../hooks/usePasskeys";

export function EnrolOutcomeNotice({
  placement,
  hidden = false,
}: {
  placement: "inline" | "gate";
  hidden?: boolean;
}) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const abandoned = useEnrollAbandoned();
  const expired = useEnrollExpired();
  if (hidden || (!abandoned && !expired)) return null;
  const text = expired
    ? t("account.passkeys.enrollExpired")
    : t("account.passkeys.enrollAbandoned");
  const dismiss = () => {
    clearEnrollAbandoned(queryClient);
    clearEnrollExpired(queryClient);
  };
  if (placement === "gate") {
    return (
      <div className="fixed bottom-4 left-4 z-50 max-w-sm rounded-xl border border-warning/30 bg-surface p-4 shadow-lg">
        <p role="alert" className="text-xs text-heading">
          {text}
        </p>
        <button
          type="button"
          onClick={dismiss}
          className="mt-3 text-xs font-medium text-muted underline transition-colors hover:text-heading"
        >
          {t("common.dismiss")}
        </button>
      </div>
    );
  }
  return (
    <div className="mt-3">
      <p role="alert" className="text-xs text-muted">
        {text}
      </p>
      <button
        type="button"
        onClick={dismiss}
        className="mt-2 text-xs font-medium text-muted underline transition-colors hover:text-heading"
      >
        {t("common.dismiss")}
      </button>
    </div>
  );
}
